import { takeLatest, put, call } from 'redux-saga/effects';
import axios from 'axios';
import {
  REFRESH_SESSION,
  setInitialState,
  setPartner,
  skipLoad,
  HANDLE_APP_LOAD,
  SET_PARTNER,
  setReferralDetails,
  setAppConfig,
  setFlippers
} from './reducer';
import jwtDecode from 'jwt-decode';
import { getRequest, postRequest } from '../utilities/requests';
import { getDecodedToken, getToken } from '../utilities/tokenStorage';
import { history } from '../utilities/history';

const postRefreshSession = () => {
  const url = '/sessions/refresh';
  return getRequest(url);
};

function* handleRefreshSession() {
  try {
    if (!getToken()) {
      return;
    }
    const response = yield postRefreshSession();
    yield handleResponse(response);
  } catch (error) {
    yield put(skipLoad());
    if (error.response) {
      if (error.response.status >= 500) {
        history.push('/error');
      }
    } else {
      history.push('/error');
    }
  }
}

function* handleResponse(response) {
  const token = (response.headers || {})['x-token'];
  const partnerDetails = jwtDecode(token);
  // setToken(token);
  yield put(setPartner(partnerDetails));
  yield put(setInitialState(response.data.initial_state));
}

export function* refreshSessionSaga() {
  yield takeLatest(REFRESH_SESSION, handleRefreshSession);
}

function* loadConfig() {
  try {
    const response = yield axios.get('/config.json', { baseURL: undefined });
    const { baseApiUrl } = response.data;
    axios.defaults.baseURL = `${baseApiUrl}/partner_web/v1`;
    yield put(setAppConfig(response.data));
  } catch (error) {
    history.push('/error');
  }
}

function* handleAppLoad() {
  try {
    yield loadConfig();
    const flippers = yield call(getFlippers);
    yield put(setFlippers(flippers.data));
    const partnerDetails = getDecodedToken();
    if (partnerDetails) {
      yield handleRefreshSession();
    } else {
      yield put(skipLoad());
    }
  } catch (error) {
    yield put(skipLoad());
    history.push('/error');
  }
}

export function* loadAppSaga() {
  yield takeLatest(HANDLE_APP_LOAD, handleAppLoad);
}

function* handleLoadReferralDetails() {
  try {
    const response = yield getRequest('/referral_details/account');
    yield put(setReferralDetails(response.data.account_info));
  } catch (error) {
    history.push('/error');
  }
}

export function* loadReferralDetailsSaga() {
  yield takeLatest(SET_PARTNER, handleLoadReferralDetails);
}

export function getFlippers() {
  const flipperFeatures = ['partner_referrals'];
  return postRequest('/flippers/check', {
    flippers: flipperFeatures
  });
}
